<template>
    <div :class="['collapsible flex flex-col w-full', appearance, { opened: opened }]">
        <div
            :class="[
                {
                    'icon-position-left flex flex-row-reverse': iconPosition === 'left',
                    'icon-position-right flex flex-row': iconPosition === 'right',
                },
                'collapsible-toggle flex-row w-full items-center cursor-pointer justify-between',
                `icon-position-${iconPosition}`,
                btnClasses,
            ]"
            @click="$emit('toggled')"
        >
            <span
                :class="headerStyle"
                v-text="header"
            ></span>
            <div
                :class="[
                    {
                        'mr-2': iconPosition === 'left',
                        'ml-2': iconPosition === 'right',
                    },
                    'icon-container flex flex-row items-center',
                ]"
            >
                <i
                    :class="[
                        {
                            'w-3 h-3': iconSize === 'xs',
                            'w-6 h-6': iconSize === 'md',
                            'w-9 h-9': iconSize === 'lg',
                        },
                        'icon ease-linear',
                        iconType,
                        iconSize,
                    ]"
                    :data-click="dataClick"
                ></i>
            </div>
        </div>
        <div class="collapsible-container text-base origin-top h-full opacity-100">
            <div
                v-show="opened"
                :class="['content-wrapper', contentClasses]"
            >
                <slot name="body"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CollapsibleItem',
    props: {
        header: {
            type: String,
            required: true,
        },
        headerStyle: {
            type: String,
            default: 'font-medium text-lg',
        },
        btnClasses: {
            type: String,
            default: 'px-6 py-4',
        },
        contentClasses: {
            type: String,
            default: 'py-5',
        },
        appearance: {
            type: String,
            default: 'default',
            validator(value) {
                // The value must match one of these strings
                return ['default', 'section'].indexOf(value) !== -1;
            },
        },
        opened: {
            type: Boolean,
            default: false,
        },
        iconSize: {
            type: String,
            default: 'md',
            validator(value) {
                // The value must match one of these strings
                return (
                    [
                        'xs',
                        'md',
                        'lg',
                        'xl',
                    ].indexOf(value) !== -1
                );
            },
        },
        iconPosition: {
            type: String,
            default: 'right',
            validator(value) {
                // The value must match one of these strings
                return ['right', 'left'].indexOf(value) !== -1;
            },
        },
        dataClick: {
            type: String,
            default: '',
        },
    },
    emits: ['toggled'],
    computed: {
        iconType() {
            return this.opened
                ? 'transform icon-chevron-circled-down rotate-180 ease-in-out duration-200'
                : 'transform icon-chevron-circled-down rotate-0 ease-in-out duration-200';
        },
    },
};
</script>

<style lang="scss" scoped>
.collapsible {
    &.default {
        .collapsible-container {
            @apply px-6;
        }
    }
    &.section {
        .collapsible-toggle {
            &.icon-position-left {
                @screen md {
                    @apply justify-end;
                }
                .icon-container {
                    @apply flex-grow;
                    @screen md {
                        @apply flex-grow-0;
                    }
                }
            }
            &.icon-position-right {
                @screen md {
                    @apply justify-start;
                }
            }
        }
    }

    &.opened {
        .collapsible-container {
            transition:
                height 400ms ease-in-out,
                opacity 400ms ease 200ms;
        }
    }
    &:not(.opened) {
        .collapsible-container {
            opacity: 0;
            height: 0;
        }
    }
}
</style>
